import React from "react";
import { FaRedditAlien } from "react-icons/fa";
import { BsTwitter, BsInstagram } from "react-icons/bs";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <div className="footer">
            <div className=" container px-0">
                <div className=" row mx-0">
                    <div className="col-lg-6 order-lg-1 order-2">
                        <div class="d-lg-flex d-none align-items-center flex-lg-row flex-column">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
                                alt=""
                            />

                            <h3 className="heading mb-0 mt-lg-0 mt-3" >it's time for innovation with a new way of farming</h3>
                        </div>
                        
                        <div className=" d-flex w-100 justify-content-lg-start mt-4 flex-wrap justify-content-center">
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f1.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f2.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f3.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f4.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f5.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f6.png"}alt=""/>
                            </a>
                            <a href="" className="social my-lg-0 my-1">
                            <img src={process.env.PUBLIC_URL + "/assets/images/f7.png"}alt=""/>
                            </a>
                        </div>
                    </div>

                    <div className="col-lg-6 pt-lg-0 pt-4 order-lg-2 order-1 d-flex justify-content-between  ">
                        <div className="d-flex flex-column">
                            <a href="" className="links">Bug Bounty</a>
                            <a href="" className="links">Contact </a>
                            <a href="" className="links">Roadmap </a>
                            <a href="" className="links">Audit </a>
                        </div>
                        <div className="d-flex flex-column">
                            <a href="" className="links">Reaper Token</a>
                            <a href="" className="links">Buyback & Burn</a>
                            <a href="" className="links">IRO</a>
                            <a href="" className="links">Swap</a>
                            <a href="" className="links">Apply Partnership</a>
                        </div>
                        <div className="d-flex flex-column">
                            <a href="" className="links">Rewards</a>
                            <a href="" className="links">Treasury</a>
                            <a href="" className="links">Farms</a>
                            <a href="" className="links">Stake</a>
                            <a href="" className="links">Partnerships</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
